
import Vue from 'vue'
import ExpectedTransformer from '@/transformers/workPlan/expected'

export default (opts={}) => {
	let url = 'workplan/expected/extranet/'
  const { residentId, finished, cancelToken, dateStart } = opts

	if (residentId) {
		url += `resident/${residentId}/`
	}

  const params = {
    finished: finished ? finished : undefined,
    date_start: dateStart || '2018-01-01'
  }

	return Vue.$http.get(url, { params, cancelToken })
		.then(response => {
			const data = ExpectedTransformer.fetchCollection(response.data)
				.sort((a, b) => a.startDate - b.startDate)
			return data
		})
}



// WEBPACK FOOTER //
// ./src/services/customersExtranet/fetchExpected.js